import EquipmentMain from './EquipmentMain.vue'

const components = {
    EquipmentMain,
}

export default {
    install(app) {
        Object.keys(components).forEach((name) => {
            const component = components[name];

            app.component(name, component);
        })
    }
}